import OrganizationModel from "#src/models/OrganizationModel.ts";
import PrivateSerieModel from "#src/models/PrivateSerieModel.ts";
import calculateCouponsForRegistration from "#src/utils/calculateCouponsForRegistration.ts";
import { calculatePricingForPrivateSerie } from "#src/utils/calculatePricingForPrivateSerie.ts";
import { coupons } from "#types/code-generator.ts";
import { v4 as uuid } from "uuid";

interface GetInvoiceItemForPrivateSerieInput {
  registration: PrivateSerieModel;
  coupons: coupons["coupons"];
  organization: OrganizationModel;
  startDate: Date;
}

export function getInvoiceItemForPrivateSerie({
  registration,
  coupons,
  organization,
  startDate,
}: GetInvoiceItemForPrivateSerieInput) {
  const pricingData = calculatePricingForPrivateSerie({
    privateSerie: registration,
    organization,
  });
  const description = `${
    registration.offering.title ?? registration.offering.type
  }: ${registration.numberOfLessons} Lesson${
    registration.numberOfLessons !== 1 ? "s" : ""
  }`;

  const registrationCoupons = calculateCouponsForRegistration({
    coupons,
    registration,
    startDate,
    organization,
  });

  const invoiceItem = {
    id: uuid(),
    amount: pricingData.price,
    description,
    discounts: pricingData.discounts,
    privateSerie: registration,
    coupons: registrationCoupons,
  };

  return invoiceItem;
}
